import { render } from "./BankCollectedAddBatchDetail.vue?vue&type=template&id=00d611c2&scoped=true"
import script from "./BankCollectedAddBatchDetail.vue?vue&type=script&lang=js"
export * from "./BankCollectedAddBatchDetail.vue?vue&type=script&lang=js"

import "./BankCollectedAddBatchDetail.vue?vue&type=style&index=0&id=00d611c2&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d611c2"]])

export default __exports__